import React, { memo } from "react";
import classNames from "classnames";
import { compose } from "redux";

import connectProps from "fantastic/lib/connectProps";

import droppable from "fantastic/components/hoc/droppable";
import selectable from "fantastic/components/hoc/selectable";

import Item from "./Item";
import EmptyItem from "./EmptyItem";

const Column = ({ items = [], id, meta }) => {
  return items && items.length > 0 ? (
    items.map(item => <Item key={item.id} {...item} checkContrast={(c) => c}/>)
  ) : (
    <EmptyItem id={id} columnType={meta.type}/>
  );
};

export default compose(selectable(), droppable("ITEM", true))(Column);
